import * as SearchConstant from "../Constants/SearchConstant";
import { DocumentationType } from "../Utils/DocumentationUtils";
import * as PathUtils from "./PathUtils";

export { debounce, clearDebounce } from "./DebounceUtils";
export { isStsDocumentation, hasBetaInUri, DocumentationType } from "../Utils/DocumentationUtils";
export { addOrUpdateQueryParameterToPathString } from "./PathUtils";

export const getSearchValue = (location) => {
    return PathUtils.getQueryParameterInPathString(location.search, SearchConstant.SearchTagName) ?? "";
}

export const getSearchOccurenceOffsetIndex = (location) => {
    if (!location || !location.hash) {
        return 0;
    }
    const value = parseInt(location.hash.split("=").slice(-1)[0]);
    return value ? value : 0;
}

export const getSearchFilterList = (location) => {
    const searchParam = new URLSearchParams(location.search);
    const filterList = [];
    for (let [key, value] of searchParam.entries()) {
        const filterNameRegEx = new RegExp("^(" + SearchConstant.SearchFilterSdkPrefix + "|" + SearchConstant.SearchFilterApiPrefix +"|" + SearchConstant.SearchFilterOtherPrefix + ")" );
        const validValue = value === "" || value === "true";
        if (key.match(filterNameRegEx) && validValue ) {
            filterList.push(key);
        }
    };
    return filterList;
}

export const getSearchTabIndex = (location) => {
    return PathUtils.getQueryParameterInPathString(location.search, SearchConstant.SearchTabIndex);
}

export const isSearchPath = (location) => {
    if (location && location.pathname.startsWith(SearchConstant.SEARCH_PATH)) {
        return true;
    }
    return false;
}

export const getValueOverMinSearchSize = (value) => {
    let overMinSizeValues = [];
    if (value) {
        overMinSizeValues = value.split(" ").filter(item => item.length >= SearchConstant.SearchMinLength);
    }
    return overMinSizeValues.join(" ");
}

export const filterSubString = (value) => {
    let filteredValues = [];
    if (value) {
        value.split(" ").map(item => {
            let add = true;
            filteredValues.map((copyValue, index) => {
                if (item.indexOf(copyValue) >= 0) {//substring
                    add = false;
                } else if (copyValue.indexOf(item) >= 0) {//substring
                    add = false;
                }
            });
            if (add) {
                filteredValues.push(item);
            }
        });
    }
    return filteredValues.join(" ");
}

export const filterSearchValue = (value) => {
    let filteredValue = "";
    if (value) {
        filteredValue = value.trim();
        filteredValue = filteredValue.replace(/:/g, "");// filter ":" because special car for lunr (search in fields)
        filteredValue = filteredValue.replace(/ +/g, " ");//filter multiple space between words
        filteredValue = getValueOverMinSearchSize(filteredValue);
        filteredValue = filterSubString(filteredValue);
    }
    return filteredValue;
}

export const ignoredSearchValues = (value) => {
    let ignoredValues = [];
    if (value) {
        const filteredValues = filterSearchValue(value);
        let indexOffset = 0;
        value.split(" ").map(item => {
            const foundIndex = filteredValues.split(" ").findIndex(filteredItem => filteredItem === item);
            if (foundIndex < 0 && item.length > 0) {//>0 to ignore " "
                ignoredValues.push({ value: item, start: indexOffset, length: item.length });
            }
            indexOffset = indexOffset + item.length + 1;//1 = espace
        });
    }
    return ignoredValues;
}

export const canStartSearch = (value, filterList) => {
    if (filterSearchValue(value).length > 0 && filterList && filterList.length > 0) {
        return true;
    }
    return false;
}

export const hasMinSearchLength = (value) => {
    if (value && value.trim().length >= SearchConstant.SearchMinLength) {
        return true;
    }
    return false;
}

export const isSearchAvailable = (indexFiles) => {
    if (!indexFiles) {
        return false;
    }
    if (Object.keys(indexFiles).length === 0) {
        return false;
    }
    return true;
}

export const hasIndexFile = (indexKey, indexFiles, documentationFilter = DocumentationType.Lts) => {
    if (!indexKey || !indexFiles) {
        return false;
    }
    let found = false
    Object.keys(indexFiles).map((key) => {
        if (key.match(new RegExp(indexKey + "Index(Common|Core|Wpf|webrtc)?(" + documentationFilter + ")?$", "i"))) {
            found = true;
        };
    });
    return found;
}

export const getAvailableOtherFilterList = (indexFiles, documentationFilter = DocumentationType.Lts) => {
    if (indexFiles == null)
        return [];

    const availableList = Object.values(SearchConstant.Other).filter((val) => {
        return hasIndexFile(val, indexFiles, documentationFilter);
    });
    return availableList.map((value) => {
        return SearchConstant.SearchFilterOtherPrefix + value;
    });
}
export const getAllOtherFilterList = () => {
    return Object.values(SearchConstant.Other).map((value) => {
        return SearchConstant.SearchFilterOtherPrefix + value;
    });
}

export const getAvailableApiFilterList = (indexFiles, documentationFilter = DocumentationType.Lts) => {
    if (indexFiles == null)
        return [];

    const availableList = Object.values(SearchConstant.Api).filter((val) => {
        return hasIndexFile(val, indexFiles, documentationFilter);
    });
    return availableList.map((value) => {
        return SearchConstant.SearchFilterApiPrefix + value;
    });
}

export const getAllApiFilterList = () => {
    return Object.values(SearchConstant.Api).map((value) => {
        return SearchConstant.SearchFilterApiPrefix + value;
    });
}

export const getAvailableSdkFilterList = (indexFiles, documentationFilter = DocumentationType.Lts) => {
    if (indexFiles == null)
        return [];

    const availableList = Object.values(SearchConstant.Sdk).filter((val) => {
        return hasIndexFile(val, indexFiles, documentationFilter);
    });
    return availableList.map((value) => {
        return SearchConstant.SearchFilterSdkPrefix + value;
    });
}

export const getAllSdkFilterList = () => {
    return Object.values(SearchConstant.Sdk).map((value) => {
        return SearchConstant.SearchFilterSdkPrefix + value;
    });
}

export const getAllAvailableSearchFilters = (indexFiles, documentationFilter = DocumentationType.Lts) => {
    const filterItemList = [];

    if (indexFiles) {
        filterItemList.push(...getAvailableSdkFilterList(indexFiles, documentationFilter));
        filterItemList.push(...getAvailableApiFilterList(indexFiles, documentationFilter));
        filterItemList.push(...getAvailableOtherFilterList(indexFiles, documentationFilter));
    }

    return filterItemList;
}

export const filterSearchFilters = (filterList, itemsToFilter) => {
    let filteredItemList = [];
    if (filterList)
        filteredItemList = filterList.filter(item => itemsToFilter.indexOf(item) >= 0);
    return filteredItemList;
}

export const getDisplayNameFromFilterItem = (searchFilterItem) => {
    if (!searchFilterItem) {
        return "";
    }
    if (searchFilterItem.startsWith(SearchConstant.SearchFilterOtherPrefix)) {
        return searchFilterItem.replace(SearchConstant.SearchFilterOtherPrefix, "");
    }
    if (searchFilterItem.startsWith(SearchConstant.SearchFilterSdkPrefix)) {
        return searchFilterItem.replace(SearchConstant.SearchFilterSdkPrefix, "");
    }
    if (searchFilterItem.startsWith(SearchConstant.SearchFilterApiPrefix)) {
        return searchFilterItem.replace(SearchConstant.SearchFilterApiPrefix, "");
    }
    return "";
}

export const hasSameContentList = (list1, list2) => {
    if (!list1 || !list2 || list1.length !== list2.length) {
        return false;
    }
    const diffList = list2.filter(item => {
        const index = list1.indexOf(item);
        return index < 0;
    });
    return diffList.length === 0;
}
